import { cn } from '@/lib/utils';
import { PRESET_OPTIONS } from '@/modules/analytics/periodOptions';
import { type Period } from '@/modules/analytics/types';

import DateFilterItem from './DateFilterItem/DateFilterItem';

interface Props {
  selected: Period | null;
  onSelect: (period: Period) => void;
  isDisabled?: (period: Period) => boolean;
  variant?: 'chip' | 'check';
  className?: string;
}

export const DateRangePresetList = ({
  selected,
  onSelect,
  isDisabled,
  variant = 'chip',
  className,
}: Props) => (
  <div className={cn('flex w-full flex-col items-start gap-1', className)}>
    {PRESET_OPTIONS.map((period) => (
      <DateFilterItem
        key={period.title_key}
        item={period}
        selected={period === selected}
        onClick={onSelect}
        disabled={isDisabled?.(period) ?? false}
        variant={variant}
      />
    ))}
  </div>
);
